import WebsiteEntertainmentModel   from '@models/website/WebsiteEntertainmentModel';
import PushNotificationStatusModel from '@models/website/PushNotificationStatusModel';
import doc                         from '@widesk-core/decorators/doc';
import WebsiteServiceModel         from '@/models/WebsiteServiceModel';
import Blamable                    from '@/models/traits/Blamable';
import { Addable }                 from '@widesk-core/decorators/addable';
import { Editable }                from '@widesk-core/decorators/editable';
import { Deletable }               from '@widesk-core/decorators/deletable';
import { Timestampable }           from '@widesk-core/decorators/timestampable';

@doc.path('/push_notifications/{?id}')
@doc.addable
@doc.editable
@doc.deletable
@doc.timestampable
abstract class AbstractPushNotificationModel extends Blamable(
	WebsiteServiceModel,
) {
	declare protected _tsFilters: {
		'partial': string;
		'sendAt[before]': id;
		'sendAt[strictly_before]': id;
		'sendAt[after]': id;
		'sendAt[strictly_after]': id;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'websiteEntertainment': id;
		'pushNotificationStatus': string;
		'errorCount[between]': id;
		'errorCount[gt]': id;
		'errorCount[gte]': id;
		'errorCount[lt]': id;
		'errorCount[lte]': id;
		'search': string;
	};

	declare private _tsSorts: {
		id: string;
		errorCount: string;
		pushNotificationStatus: string;
		sendAt: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.model(WebsiteEntertainmentModel)
	declare websiteEntertainment: WebsiteEntertainmentModel;
	@doc.number declare errorCount: number;
	@doc.model(PushNotificationStatusModel)
	declare pushNotificationStatus: PushNotificationStatusModel;
	@doc.date declare sendAt: Dayjs;
}

interface AbstractPushNotificationModel
	extends Addable,
		Editable,
		Deletable,
		Timestampable {}

export default AbstractPushNotificationModel;
